module.exports = __webpack_public_path__ + "static/2-57277d84b5b5284e440ee66b41de306e.jpeg";